export default {
  order: 1,
  layerGroupId: 'GROUP_LC',
  dataLayer: {
    id: 'IFL',
    order: 1,
    type: 'remoteDataLayer',
    uuid: '5f815a7d-457e-4eae-a8e5-8864a60696ad',
    groupId: 'GROUP_LC',
  },
  layer: {
    metadata: {
      metadata: null,
      legendConfig: {
        source: '(2000/2013/2016)',
        type: 'basic',
        name: {
          en: 'Intact Forest Landscape',
          fr: 'Paysage de la forêt vierge',
          es: 'Paisaje forestal intacto',
          pt: 'Paisagens Florestais Intactas',
          id: 'Lanskap Hutan Utuh',
          zh: '原生森林景观',
          ka: 'ხელუხლებელი ტყის ლანდშაფტი',
        },
        items: [
          {
            name: {
              en: 'Intact Forest Landscape',
              fr: 'Paysage de la forêt vierge',
              es: 'Paisaje forestal intacto',
              pt: 'Paisagem florestal intacta',
              id: 'Lanskap Hutan Utuh',
              zh: '原生森林景观',
              ka: 'ხელუხლებელი ტყის ლანდშაფტი',
            },
            color: '#136400',
          },
          {
            name: {
              en: 'Reduction in extent 2000-2013',
              fr: 'Diminution de l’étendue 2000 - 2013',
              es: 'Reducción en la extensión 2000 a 2013',
              pt: 'Redução em extensão 2000 – 2013',
              id: 'Pengurangan Luasan pada 2000 - 2013',
              zh: '2000 - 2013 年减少程度',
              ka: 'სიდიდის შემცირება 2000-2013',
            },
            color: '#969904',
          },
          {
            name: {
              en: 'Reduction in extent 2013-2016',
              fr: 'Diminution de l’étendue 2013 - 2016',
              es: 'Reducción en la extensión 2013 a 2016',
              pt: 'Redução em extensão 2013 – 2016',
              id: 'Pengurangan Luasan pada 2013 - 2016',
              zh: '2013 - 2016 年减少程度',
              ka: 'სიდიდის შემცირება 2013-2016',
            },
            color: '#635731',
          },
        ],
      },
      interactionConfig: {},
    },
    id: 'IFL',
    type: 'Vector.Layer',
    url: 'https://tiles.globalforestwatch.org/ifl_intact_forest_landscapes/v2018/default/root.json',
    layerIds: [16],
    technicalName: 'intact_forest_landscapes_change',
    label: {
      en: 'Intact Forest Landscape',
      fr: 'Paysage de la forêt vierge',
      es: 'Paisaje forestal intacto',
      pt: 'Paisagem florestal intacta',
      id: 'Intact Forest Landscape',
      zh: '原生林景观',
      ka: 'ხელუხლებელი ტყის ლანდშაფტი',
    },
    sublabel: {
      en: '(2000/2013/2016, global, UMD/WRI/Greenpeace/Transparent World)',
      fr: '(2000/2013/2016, mondial, UMD/WRI/Greenpeace/Transparent World)',
      es: '(2000/2013/2016, global, UMD/WRI/Greenpeace/Transparent World)',
      pt: '(2000/2013/2016, global, UMD/WRI/Greenpeace/Transparent World)',
      id: '(2000/2013/2016, global, UMD/WRI/Greenpeace/Transparent World)',
      zh: '(2000/2013/2016 年，全球，UMD/WRI/Greenpeace/Transparent World）',
      ka: '(2000/2013/2016, გლობალური, UMD/WRI/Greenpeace/Transparent World)',
    },
  },
  isMetadataError: false,
  isError: false,
};
